import { SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_UNIT_TYPE_UNITS_GET } from 'api/utilityActionTypes';

import { buildGetPmsUnitTypeUnitsAction } from './pmsUnitTypes.shared';

export default buildGetPmsUnitTypeUnitsAction(
  SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_UNIT_TYPE_UNITS_GET,
);
